Alpine.data('mediaSlider', mediaSlider);

export default function mediaSlider(config = {}) {
	return {
		swiper: null,
		videoUrls: [],
		currentVideoIndex: 0,
		videoCount: config.videoCount,
		photoCount: config.photoCount,
		audioCount: config.audioCount,

		initSwiper() {
			if (typeof window.Swiper === 'undefined') {
				console.error('Swiper is not loaded');
				return;
			}

			this.swiper = new window.Swiper(this.$refs.swiperContainer, {
				modules: [window.SwiperNavigation],
				lazy: true,
				lazyPreloadPrevNext: 1,
				navigation: {
					nextEl: '.swiper-next-button',
					prevEl: '.swiper-prev-button',
				},

				rewind: true,
				effect: 'slide',
				speed: 500,
				on: {
					slideChange: () => {
						// If the audio player is loaded, make sure it stops playing if we navigate away from the audio slide
						window.audioPlayer ? window.audioPlayer.pause() : null;
						this.highlightShortcutLink();
					},
				},
			});

			this.collectVideoUrls();
			this.highlightShortcutLink();
		},

		checkMissingYouTubeVideo(event, promokit_id, video_id) {
			if (event.target.naturalWidth === 120) {
				fetch(`/ajax/hide_missing_video/${promokit_id}/${video_id}`).catch((error) => console.error('Error reporting missing YouTube video:', error));
			}
		},

		closeVideoModal() {
			// Destroy the video player container
			if (this.$refs.videoPlayerContainer) {
				this.$refs.videoPlayerContainer.innerHTML = '';
			}

			// Close the modal if it exists and is currently open
			if (this.$refs.videoModal && this.$refs.videoModal.open) {
				this.$refs.videoModal.close();
			}
		},

		collectVideoUrls() {
			// Collect all video URLs from the slides
			this.videoUrls = [];
			const videoSlides = document.querySelectorAll('.swiper-slide[data-video-src]');
			videoSlides.forEach((slide) => {
				const videoSrc = slide.getAttribute('data-video-src');
				if (videoSrc) {
					this.videoUrls.push(videoSrc);
				}
			});
		},

		goToMedia(type) {
			switch (type) {
				case 'video':
					this.goToVideo();
					break;
				case 'audio':
					this.goToAudio();
					break;
				case 'photo':
					this.goToPhoto();
					break;
				default:
					break;
			}
		},

		goToAudio() {
			this.swiper.slideTo(this.videoCount);
		},

		goToPhoto() {
			let index = this.videoCount;
			if (this.audioCount > 0) {
				index++;
			}

			this.swiper.slideTo(index);
		},

		goToVideo() {
			this.swiper.slideTo(0);
		},

		highlightShortcutLink() {
			const slide = this.swiper.slides[this.swiper.realIndex];
			const videoLink = this.$refs.videoShortcut ?? null;
			const audioLink = this.$refs.audioShortcut ?? null;
			const photoLink = this.$refs.photoShortcut ?? null;

			// Add active state style to shortcut link for the current media type
			if (slide.hasAttribute('data-video-slide')) {
				videoLink ? videoLink.classList.add('bg-fuchsia/20') : null;
				audioLink ? audioLink.classList.remove('bg-fuchsia/20') : null;
				photoLink ? photoLink.classList.remove('bg-fuchsia/20') : null;
			} else if (slide.hasAttribute('data-audio-slide')) {
				videoLink ? videoLink.classList.remove('bg-fuchsia/20') : null;
				audioLink ? audioLink.classList.add('bg-fuchsia/20') : null;
				photoLink ? photoLink.classList.remove('bg-fuchsia/20') : null;
			} else if (slide.hasAttribute('data-photo-slide')) {
				videoLink ? videoLink.classList.remove('bg-fuchsia/20') : null;
				audioLink ? audioLink.classList.remove('bg-fuchsia/20') : null;
				photoLink ? photoLink.classList.add('bg-fuchsia/20') : null;
			}
		},

		loadCurrentVideo() {
			if (!this.$refs.videoPlayerContainer) {
				return;
			}

			// Load the current video
			this.$refs.videoPlayerContainer.innerHTML = '';

			if (this.videoUrls[this.currentVideoIndex]) {
				const iframe = document.createElement('iframe');
				iframe.src = `${this.videoUrls[this.currentVideoIndex]}?autoplay=1`;
				iframe.className = 'w-full h-full rounded-xl';
				iframe.frameBorder = '0';
				iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope';
				iframe.allowFullscreen = true;
				this.$refs.videoPlayerContainer.appendChild(iframe);
			}
		},

		nextVideo() {
			// Increment the index and wrap around if needed
			this.currentVideoIndex = (this.currentVideoIndex + 1) % this.videoUrls.length;
			this.loadCurrentVideo();
		},

		openVideoModal(srcUrl) {
			this.currentVideoIndex = this.videoUrls.indexOf(srcUrl);
			if (this.currentVideoIndex === -1) {
				this.currentVideoIndex = 0;
			}

			// Set the video source, open the modal, and start playback
			this.loadCurrentVideo();

			this.$refs.videoModal.showModal();
		},

		prevVideo() {
			// Decrement the index and wrap around if needed
			this.currentVideoIndex = (this.currentVideoIndex - 1 + this.videoUrls.length) % this.videoUrls.length;
			this.loadCurrentVideo();
		},
	};
}
